import React, { useEffect, useState } from 'react';
import './TreasuryYields.css';

// Compact live US Treasury yields strip (2Y/10Y/30Y ...) with daily change and
// the 2s10s spread. Alpha references these constantly; this gives the user a
// place to watch them. Fetches the cached /api/market/treasury endpoint;
// renders nothing if unavailable.
const TENORS = [
  { key: 'y3m', label: '3M' },
  { key: 'y2', label: '2Y' },
  { key: 'y5', label: '5Y' },
  { key: 'y10', label: '10Y' },
  { key: 'y30', label: '30Y' },
];

export default function TreasuryYields() {
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    fetch('/api/market/treasury')
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('unavailable'))))
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, []);

  if (failed || !data || !data.yields) return null;

  const fmtChg = (c) => (c == null ? '—' : `${c >= 0 ? '+' : ''}${Math.round(c * 100)} bp`);
  const spread = data.spread_2s10s;

  return (
    <div className="tyw">
      <div className="tyw-head">
        <span className="tyw-title">US Treasury Yields</span>
        {spread != null && (
          <span className={`tyw-spread ${spread < 0 ? 'inv' : ''}`}>
            2s10s {spread >= 0 ? '+' : ''}{spread.toFixed(2)}%{spread < 0 ? ' · inverted' : ''}
          </span>
        )}
      </div>
      <div className="tyw-row">
        {TENORS.map((t) => {
          const y = data.yields[t.key];
          if (y == null) return null;
          const c = data.change[t.key];
          return (
            <div className="tyw-cell" key={t.key}>
              <span className="tyw-tenor">{t.label}</span>
              <span className="tyw-val">{y.toFixed(2)}%</span>
              <span className={`tyw-chg ${c == null ? '' : c >= 0 ? 'up' : 'down'}`}>{fmtChg(c)}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
